<div class="slide slide--media-type" [style.--slide-accent-color]="titleColor">
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>

		<div class="slide__kpi" *ngIf="!isEmpty && kpiValue">
			<typography variant="h/1" class="slide__kpi-value">
				{{ kpiValue }}
			</typography>
			<div class="slide__kpi-label-row">
				<span class="slide__kpi-dot"></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					{{ kpiLabel }}
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="!isEmpty && chartData">
		<div class="slide__chart-panel">
			<div class="slide__chart-head">
				<typography variant="p/base_medium" class="slide__chart-title">
					{{ chartSectionTitle }}
				</typography>
				<div class="slide__legend">
					<div
						class="slide__legend-item"
						*ngFor="let item of legendItems"
					>
						<span
							class="slide__legend-swatch"
							[style.background]="item.color"
						></span>
						<typography
							variant="p/xs_medium"
							class="slide__legend-label"
						>
							{{ item.label }}
						</typography>
					</div>
				</div>
			</div>
			<div class="slide__chart slide__chart-host">
				<canvas
					*ngIf="!chartSwitch.block"
					baseChart
					[data]="chartData"
					[options]="chartOptions"
					[type]="chartType"
				></canvas>
				<app-report-chart-switch
					[state]="chartSwitch"
					[themeColor]="themeColor"
					[editorMode]="editorMode"
					(chartTypeChange)="chartTypeChange.emit($event)"
				></app-report-chart-switch>
			</div>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">sentiment by media type</div>
	</div>
</div>
